import React, {Component} from 'react'
import {FormattedDate} from 'react-intl'
import PropTypes from 'prop-types'

export default class Date extends Component {
    render() {
        const date = this.props.date;
        if (date) {
            return <FormattedDate value={date} day='2-digit' month='2-digit' year='numeric'/>
        } else {
            return <span> </span>
        }
    }
}

Date.propTypes = {
    date: PropTypes.string
}
